import { PLATFORM_TENANT_KEY } from '@actions/services/agents/platformTenancy';
import type { ResolveSystemAgentPartitionOrganizationIdParams } from '../types';

/**
 * Org routes pass the customer org as `:agentId`. Admin platform routes omit it;
 * fall back to the reserved platform partition key.
 */
const resolveSystemAgentPartitionOrganizationId = ({
    routeOrganizationId,
}: ResolveSystemAgentPartitionOrganizationIdParams): string => {
    if (routeOrganizationId && routeOrganizationId.length > 0) {
        return routeOrganizationId;
    }
    return PLATFORM_TENANT_KEY;
};

export default resolveSystemAgentPartitionOrganizationId;
